import type { ValidationRule } from 'react-hook-form';
import type { ITranslation } from '../interfaces/generic';

export const requiredField = (message: string): ValidationRule<boolean> => ({ value: true, message });

export const isValidTranslationFields = (translations: ITranslation) =>
    translations && Object.keys(translations).length > 0 && Object.values(translations).every((value) => !!value);
